var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { boundMethod } from 'autobind-decorator';
import { v4 as uuidv4 } from 'uuid';
import { InvalidResponseError, TransportAlreadyStartedError } from '../../types';
export class WebWebsocketStreamingProvider {
    constructor({ webSocketsService, roomId, userId }) {
        this.awaitingResponsesBuffer = [];
        this.signalOnNewResponses = null;
        this.webSocketsService = webSocketsService;
        this.roomId = roomId;
        this.userId = userId;
    }
    onResponse(data) {
        if (!data) {
            throw new InvalidResponseError();
        }
        this.awaitingResponsesBuffer = [...this.awaitingResponsesBuffer, data];
        // Signal on the next responses
        if (this.signalOnNewResponses) {
            this.signalOnNewResponses();
            this.signalOnNewResponses = null;
        }
    }
    async start() {
        if (this.websocketCallbackId) {
            throw new TransportAlreadyStartedError();
        }
        this.websocketCallbackId = uuidv4();
        try {
            const namespace = {
                userId: this.userId
            };
            const namespaceToken = await this.webSocketsService.getNamespaceToken(namespace, 'streaming');
            this.leaveRoomCB = this.webSocketsService.joinRoom({
                callback: this.onResponse,
                callbackId: this.websocketCallbackId,
                roomName: this.roomId,
                namespace,
                namespaceToken
            });
        }
        catch (e) {
            this.clean();
        }
    }
    async stop() {
        if (!this.websocketCallbackId) {
            return;
        }
        if (this.leaveRoomCB) {
            this.leaveRoomCB();
        }
        this.clean();
    }
    clean() {
        this.websocketCallbackId = null;
        this.leaveRoomCB = null;
    }
    async *stream() {
        while (true) {
            if (this.awaitingResponsesBuffer.length === 0) {
                // Nothing ready yet - wait for next push
                await new Promise(resolve => {
                    this.signalOnNewResponses = resolve;
                });
                continue;
            }
            yield this.awaitingResponsesBuffer.shift();
        }
    }
}
__decorate([
    boundMethod
], WebWebsocketStreamingProvider.prototype, "onResponse", null);
//# sourceMappingURL=web-websocket-streaming.provider.js.map